import { render, staticRenderFns } from "./workForm.vue?vue&type=template&id=71818e1f&scoped=true&"
import script from "./workForm.vue?vue&type=script&lang=js&"
export * from "./workForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71818e1f",
  null
  
)

export default component.exports